import { Box, CircularProgress } from "@mui/material";
import { CloudOutlined as CloudOutlinedIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { LOGIN_PAGE_NS } from "./i18n";

export const SyncingBlock = () => {
    const { t } = useTranslation(LOGIN_PAGE_NS);

    return (
        <Box
            style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
        >
            <CloudOutlinedIcon sx={{ fontSize: 100 }} />
            <Box style={{ position: "relative", top: "-55px" }}>
                <CircularProgress size={18} />
            </Box>
            {t("syncing.sync")}
        </Box>
    )
};